const apiPaths = {
  RETRIEVE_STORY: "v3/retrieveStory",
  POST_STORY_UPDATE: "v3/updateStory",
  RETRIEVE_TEMPLATE_LIST: "retrieveTemplates",
  CONTENT_BASE_URL2: "",
  STORY_OPTION_VIEW1:
    "https://assets.prod.yetimyfriend.com/troo_heart_cf4d90abc8.json",
  STORY_OPTION_VIEW2:
    "https://assets.prod.yetimyfriend.com/troo_dancing_d46c7c8acd.json",
  STORY_OPTION_VIEW3:
    "https://assets.prod.yetimyfriend.com/troo_confident_eab5dc81f0.json",
  STORY_BREAK_PRE_RENDER_AUDIO:
    "https://assets.prod.yetimyfriend.com/Troo_Ooh_I_hear_a_buzz_looks_like_the_magic_backpack_has_something_to_share_with_us_5ea87c56bb.mp3",
  STORY_BREAK_PRE_RENDER_TEXT:
    "Oooh, I hear a buzz… looks like there’s something from the magic backpack…",
};

export default apiPaths;
